module.exports = __webpack_public_path__ + "img/cydia-pomonella.7ee06cac.jpg";